module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-easy-invoicing-0dfc17b4b3f3b595f97ba5e36cc43c63.png";